module.exports = __webpack_public_path__ + "static/media/ffas.7cd7142c.png";